import React from "react";
import { connect } from "react-redux";
import { Table } from "reactstrap";

const mapStateToProps = (state) => {
    return {
        getCatalogoCobroDetail: state.CatalogoCobroReducer.getCatalogoCobroDetail,
        errorCatalogoCobroDetail: state.CatalogoCobroReducer.errorCatalogoCobroDetail,
    };
};

const CatalogoCobroDetail = (props) => {
    //console.log("Javier -->sssss " + props.getCatalogoCobroDetail.length);

    
    //for (const property in props.getCatalogoCobroDetail) {
    //    console.log(`${property}: ${props.getCatalogoCobroDetail[property]}`);
    //}
    

    //console.log(Object.entries(props.getCatalogoCobroDetail));

    //var map = new Map(Object.entries(props.getCatalogoCobroDetail));
    //console.log(map); // Map { foo: "bar", baz: 42 }


    const isEmpty = props.getCatalogoCobroDetail.length === 0;

    const catalogocobro = Object.values(props.getCatalogoCobroDetail);
    //console.log(catalogocobro)


    /*
    Object.entries(props.getCatalogoCobroDetail).forEach(([key, value]) => {
        console.log(key + ' ddd ' + value); // "a 5", "b 7", "c 9"
    });
    */

    return (
        

        <Table striped>
            <tbody>


                {isEmpty ?
                    <div>There are no results</div>
                    :
                    catalogocobro.map(item =>
                        <>
                        <tr>
                        <td width="200">Nombre</td>
                        <td width="10">:</td>
                        <td>{item.nombre}</td>
                    </tr><tr>
                            <td width="200">Descripción</td>
                            <td width="10">:</td>
                            <td>{item.descripcion}</td>
                        </tr><tr>
                            <td width="200">Precio</td>
                            <td width="10">:</td>
                            <td>{item.precio}</td>
                        </tr><tr>
                            <td width="200">Tipo</td>
                            <td width="10">:</td>
                            <td>{item.tipo}</td>
                        </tr>

                        <tr>
                            <td width="200">Vigente</td>
                            <td width="10">:</td>
                            <td>{item.abrir}</td>
                        </tr>

                        <tr>
                            <td width="200">Activo</td>
                            <td width="10">:</td>
                                <td>{(item.activo?"SI":"NO")}</td>
                        </tr>

                        <tr>
                            <td width="200">Fecha Alta</td>
                            <td width="10">:</td>
                            <td>{item.fechaalta}</td>
                        </tr>
                        </>
                        )
                }



               
            </tbody>
        </Table>
    );
};

export default connect(mapStateToProps, null)(CatalogoCobroDetail);
